import React from 'react';
import S from './styles';
import { TimetableItem } from "../timetable-item"

const timetableList = [
  {
    label: '13:00',
    title: '개회사',
    badge: ['Kuu'],
  },
  {
    label: '13:10',
    title: 'SwiftUI를 도입하기 전 대비하는 자세 feat: RxSwift 의존도 줄이기',
    badge: ['Rubin'],
  },
    {
        label: '13:30',
        title: 'MVI Architecture',
        badge: ['태태'],
    },
    {
      label: '14:00',
      title: '휴식',
      badge: [''],
  },
    {
        label: '14:10',
        title: '공정사회를 위한 엔지니어링: 모두를 위한 앱 만들기',
        badge: ['태승'],
    },
    {
        label: '14:40',
        title: '네트워킹 및 기념사진 촬영',
        badge: ['모두'],
    },
    {
        label: '15:30',
        title: '느슨한 결합을 몸으로 느껴보자',
        badge: ['클라인'],
    },
  {
    label: '16:00',
    title: '회사가 즐거워진 신입',
    badge: ['스위리'],
  },
  {
    label: '16:20',
    title: '휴식',
    badge: [''],
  },
    {
        label: '16:30',
        title: 'CI/CD 최종보스 UITesting 두둥등장',
        badge: ['HanSJin'],
    },
  {
    label: '17:00',
    title: '폐회사 및 뒷풀이 안내',
    badge: ['Kuu'],
  },
];

export const Timetable = () => (
  <S.Section>
    <S.Title
      id='timetable'
      data-sal="slide-up"
      data-sal-delay="100"
      data-sal-duration="600"
      data-sal-easing="ease"
    >
      TIMETABLE
    </S.Title>
    <S.Wrap>
      {timetableList.map((item, index) => (<TimetableItem item={item} index={index} key={item.title} />))}
    </S.Wrap>
  </S.Section>
)
